module.exports = __webpack_public_path__ + "media/images/wealthbar/2fa/2fa-locked-lock-2fb0c322ab6e6d6c9eb21a7f7da4fb49.png";